const OKAccelerometerMonthlyChart = require('okCharts/OKAccelerometerMonthlyChart/OKAccelerometerMonthlyChart');

module.exports = OKAccelerometerMonthlyChart;
